require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./research-targeted-therapy-against-triple-negative-breast-cancers.json") })
        }
      }, "path---research-targeted-therapy-against-triple-negative-breast-cancers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---research-targeted-therapy-against-triple-negative-breast-cancers!./.cache/json/research-targeted-therapy-against-triple-negative-breast-cancers.json
// module id = 490
// module chunks = 231608221292675